var gScope;
/******/ (function() { // webpackBootstrap
  /******/ 	"use strict";
  /******/ 	// The require scope
  /******/ 	var __webpack_require__ = {};
  /******/
  /************************************************************************/
  /******/ 	/* webpack/runtime/make namespace object */
  /******/ 	!function() {
    /******/ 		// define __esModule on exports
    /******/ 		__webpack_require__.r = function(exports) {
      /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
        /******/ 			}
      /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
      /******/ 		};
    /******/ 	}();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  __webpack_require__.r(__webpack_exports__);
// Styles


  if (!window.dAgency) window.dAgency = {};
  window.dAgency.initBlocksSlider = (context) => {
    const blocksSliderSection = context.closest('.shopify-section');
    if (!blocksSliderSection) return;

    const slider = blocksSliderSection.querySelector('.blocks-slider__blocks-container');
    const suffixId = slider.children[0] ? slider.children[0].id.split('---')[0] : '';
    blocksSliderSection.setAttribute('current-slide', 1);
    const icon_right = context.querySelector('.blocks-slider__scroll-header .icon-chevron-right');
    const icon_left = context.querySelector('.blocks-slider__scroll-header .icon-chevron-left');
    const slide_width = slider.children[0] ? slider.children[0].offsetWidth : -1;

    icon_left.addEventListener("click", function () {
      var slide = blocksSliderSection.getAttribute('current-slide');
      slide--;
      const scrollTo = document.getElementById(suffixId + '---' + slide);
      if (scrollTo) {
        $(slider).animate({ scrollLeft: scrollTo.offsetLeft - 26 }, 600);
        blocksSliderSection.setAttribute('current-slide', slide);
        icon_right.setAttribute('aria-disabled', false)
      }

      if (slide == 1) {
        icon_left.setAttribute('aria-disabled', true)
      }
    });

    icon_right.addEventListener("click", function () {

      var slide = blocksSliderSection.getAttribute('current-slide');
      slide++;

      const scrollTo = document.getElementById(suffixId + '---' + slide);
      const max_slide = Math.ceil((slider.scrollWidth - slider.offsetWidth) / slide_width) + 1;
      if (scrollTo && slide <= max_slide) {
        $(slider).animate({ scrollLeft: scrollTo.offsetLeft }, 600);
        blocksSliderSection.setAttribute('current-slide', slide);
        icon_left.setAttribute('aria-disabled', false)
      }

      if (slide == max_slide) {
        icon_right.setAttribute('aria-disabled', true)
      }

    });

    var isDown = false;
    var startX;
    var scrollLeft;

    slider.addEventListener('scroll', () => {
      if (slider.scrollLeft > 20) {
        icon_left.setAttribute('aria-disabled', false);
      } else {
        icon_left.setAttribute('aria-disabled', true);
      }

      if (slider.scrollLeft + slider.clientWidth + 20 < slider.scrollWidth) {
        icon_right.setAttribute('aria-disabled', false);
      } else {
        icon_right.setAttribute('aria-disabled', true);
      }
    });

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  if (document.readyState != "loading") {
    [].forEach.call(document.querySelectorAll('.blocks-slider__container'), (el) => {
      window.dAgency.initBlocksSlider(el);
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      [].forEach.call(document.querySelectorAll('.blocks-slider__container'), (el) => {
        window.dAgency.initBlocksSlider(el);
      });
    });
  }

  gScope = __webpack_exports__;
  /******/ })()
;
